import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-cheer px-5 py-20 sm:px-8" data-id="element-119" data-mp="1o2vfqkp72f4g">
      <Reveal className="mx-auto w-full max-w-2xl" data-id="element-120" data-mp="223685s65k1rq">
        <div className="rounded-card bg-white px-6 py-12 text-center shadow-xl sm:px-12" data-id="element-121" data-mp="222n2b9ts13u2">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold" data-id="element-122" data-mp="1x4uzvlvi9zbm">
            <ShieldCheckIcon className="h-8 w-8 text-navy" aria-hidden="true" data-id="element-123" data-mp="19fad0rw8ehx2" />
          </span>

          <h2 className="mt-6 font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-124" data-mp="14h8wadma2uor">
            7-Day <span className="text-cheer" data-id="element-125" data-mp="1j5vbmfbwnmfz">Guarantee</span>
          </h2>

          <p className="mx-auto mt-5 max-w-lg text-base leading-relaxed text-navy/75" data-id="element-126" data-mp="1ed25po4pa82b">
            Try Cheerleading Ready 360 risk-free. If you're not satisfied, we'll refund you
            100%, no questions asked.
          </p>

          <p className="mt-4 text-xs font-bold uppercase tracking-widest text-navy/50" data-id="element-127" data-mp="ln2bcj7tsddp">
            No credit card tricks. No conditions.
          </p>

          <a href="#pricing" className="mt-8 inline-flex items-center justify-center rounded-full border-b-2 border-cheer font-display text-sm font-extrabold uppercase tracking-tight text-cheer transition-colors duration-150 ease-out hover:text-[#ad1457] focus:outline-none focus-visible:ring-2 focus-visible:ring-cheer/40" data-id="element-128" data-mp="txt7gwtgkfbt">
            Claim your copy risk-free
          </a>
        </div>
      </Reveal>
    </section>;
}